import { BracketWinnerEnum } from "../BracketWinnerEnum";

export default class BracketGameFixtures {
  public matchId: string = "";
  public participantOne: string = "";
  public participantTwo: string = "";
  public winner: BracketWinnerEnum = BracketWinnerEnum.PARTICIPANT_ONE;
}
